module.exports = __webpack_public_path__ + "static/worldleprosy-030c274ce1b7895b84cf5dad3946c3aa.png";